module.exports = __webpack_public_path__ + "static/legacy_honor_bgM@2x-e20282a7b0436db47c5d24febeda6dc8.jpg";